import { SmartfireComponent } from '@smartfire/gutenberg-react';
import './style.scss';
import iconLinkedIn from '../assets/icon_linkedin.svg';
import iconFacebook from '../assets/icon_facebook.svg';
import iconTwitter from '../assets/icon_twitter.svg';
import iconInstagram from '../assets/icon_instagram.svg';
import iconYoutube from '../assets/icon_youtube.svg';
import React from 'react';
import { ReactComponent as Arrow } from './fleche.svg';
import { ReactComponent as Phone } from './phone.svg';

export default class FooterBlock extends SmartfireComponent {
    state = {
        newsletterActive: false,
    };

    showPopupDevis = () => {
        let event = new CustomEvent('toggle-popup-devis');
        document.dispatchEvent(event);
    };

    showNewsletter = () => {
        this.setState({ newsletterActive: true }, () => {
            this.refs.newsletterInput.focus();
        });
    };

    saveNewsletter = (e) => {
        e.preventDefault();
        let email = this.refs.newsletterInput.value;
        let emailReg =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailReg.test(email)) {
            alert("L'adresse email est invalide");
            return;
        }

        const data = {
            action: 'save_newsletter',
            nl_id: 1,
            nl_name: 'Newsletter',
            nl_data: 'EMAIL=' + email,
        };

        window.jQuery.post('/wp-admin/admin-ajax.php', data, () => {
            this.refs.newsletterInput.value = '';
            this.setState({ newsletterActive: false });
        });
    };

    render() {
        return (
            <div className="footer-block">
                <div className="content-container">
                    <div className="columns">
                        <div className="column">
                            <div className="logo">
                                <img src={this.props.website.logo} alt="logo de Capsa" />
                            </div>
                            <ul className="social-icons">
                                {this.props.website.linkedInLink ? (
                                    <a
                                        href={this.props.website.linkedInLink}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        <li>
                                            <img src={iconLinkedIn} alt="linkedin" />
                                        </li>
                                    </a>
                                ) : (
                                    ''
                                )}
                                {this.props.website.instagramLink ? (
                                    <a
                                        href={this.props.website.instagramLink}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        <li>
                                            <img src={iconInstagram} alt="instagram" />
                                        </li>
                                    </a>
                                ) : (
                                    ''
                                )}
                                {this.props.website.facebookLink ? (
                                    <a
                                        href={this.props.website.facebookLink}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        <li>
                                            <img src={iconFacebook} alt="facebook" />
                                        </li>
                                    </a>
                                ) : (
                                    ''
                                )}
                                {this.props.website.twitterLink ? (
                                    <a
                                        href={this.props.website.twitterLink}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        <li>
                                            <img src={iconTwitter} alt="twitter" />
                                        </li>
                                    </a>
                                ) : (
                                    ''
                                )}
                                {this.props.website.youtubeLink ? (
                                    <a
                                        href={this.props.website.youtubeLink}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        <li>
                                            <img src={iconYoutube} alt="youtube" />
                                        </li>
                                    </a>
                                ) : (
                                    ''
                                )}
                            </ul>
                        </div>
                        <div className="column list">
                            <p className="links-title">Sitemap</p>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: this.props.menuSitemap,
                                }}
                            />
                        </div>
                        <div className="column list">
                            <p className="links-title">Nos dépôts</p>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: this.props.menuDepots,
                                }}
                            />
                        </div>
                        <div className="column">
                            <button
                                className="footer-button"
                                onClick={() => {
                                    this.showPopupDevis();
                                }}
                            >
                                <Arrow />
                                Demande de devis
                            </button>
                            <a
                                className="footer-quotation-phone"
                                href={'tel:' + this.props.website.phone}
                            >
                                <Phone />
                                {this.props.website.phone}
                            </a>
                            <p className="footer-title">
                                Abonnez-vous
                                <br />à notre newsletter
                            </p>
                            <button
                                className="footer-button"
                                onClick={() => this.showNewsletter()}
                            >
                                <Arrow />
                                S'inscrire à la newsletter
                            </button>
                            {this.state.newsletterActive && (
                                <form
                                    className="newsletter-form"
                                    onSubmit={(e) => this.saveNewsletter(e)}
                                >
                                    <input
                                        className="newsletter-email"
                                        placeholder="Votre email"
                                        ref="newsletterInput"
                                    />
                                    <input
                                        type="submit"
                                        className="newsletter-submit"
                                        value="ok"
                                    />
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
